import { render, staticRenderFns } from "./TxList.vue?vue&type=template&id=2c30733a&scoped=true&"
import script from "./TxList.vue?vue&type=script&lang=js&"
export * from "./TxList.vue?vue&type=script&lang=js&"
import style0 from "./TxList.vue?vue&type=style&index=0&id=2c30733a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c30733a",
  null
  
)

export default component.exports